export const inferFirstDiscoveryYear = (discoveryCounts) => {
  if (!discoveryCounts || discoveryCounts.length === 0) return null;
  const first = discoveryCounts.find(item => item.count > 0);
  return first ? first.year : null;
};

export const filterDiscoveryCounts = (discoveryCounts, startYear) => {
  if (!discoveryCounts || !Number.isFinite(startYear)) return [];
  return discoveryCounts.filter(item => item.year >= startYear);
};

export const buildCumulativePointsFromCounts = (discoveryCounts, modelStartYear) => {
  if (!discoveryCounts || !Number.isFinite(modelStartYear)) return [];
  const filtered = filterDiscoveryCounts(discoveryCounts, modelStartYear);
  let cumulative = 0;
  return filtered
    .map((item) => {
      cumulative += item.count;
      return { x: item.year - modelStartYear, y: cumulative, year: item.year };
    })
    .filter(point => point.y > 0);
};

export const buildDiscoveryCountsFromTimes = (times, startYear, endYear) => {
  const counts = {};
  times.forEach((t) => {
    const year = Math.floor(startYear + t);
    const clampedYear = Math.max(startYear, Math.min(endYear, year));
    counts[clampedYear] = (counts[clampedYear] || 0) + 1;
  });
  const discovery = [];
  for (let year = startYear; year <= endYear; year += 1) {
    discovery.push({ year, count: counts[year] || 0 });
  }
  return discovery;
};

export const buildDiscoverySeries = (records, startYear, endYear) => {
  if (!records || records.length === 0 || startYear === 0 || endYear === 0) {
    return {
      chartData: [],
      discoveryCounts: [],
      currentCount: 0,
      fitPoints: [],
    };
  }

  const yearlyCounts = records.reduce((acc, item) => {
    const year = Number(item.year);
    if (!Number.isFinite(year)) return acc;
    acc[year] = (acc[year] || 0) + 1;
    return acc;
  }, {});

  const data = [];
  const discovery = [];
  let cumulative = 0;
  for (let year = startYear; year <= endYear; year += 1) {
    const count = yearlyCounts[year] || 0;
    cumulative += count;
    data.push({ year, observed: cumulative });
    discovery.push({ year, count });
  }

  const fitPoints = data
    .map(point => ({ x: point.year, y: point.observed }))
    .filter(point => point.y > 0);

  return {
    chartData: data,
    discoveryCounts: discovery,
    currentCount: data.length ? data[data.length - 1].observed : 0,
    fitPoints,
  };
};

export const countNonZeroYears = (discoveryCounts) => (
  discoveryCounts.reduce((acc, item) => acc + (item.count > 0 ? 1 : 0), 0)
);

export const computeSpanYears = (records, startYear, endYear) => {
  if (!records || records.length === 0) return 0;
  let minYear = Infinity;
  let maxYear = -Infinity;
  records.forEach((item) => {
    const year = Number(item.year);
    if (!Number.isFinite(year)) return;
    if (year < startYear || year > endYear) return;
    if (year < minYear) minYear = year;
    if (year > maxYear) maxYear = year;
  });
  if (!Number.isFinite(minYear) || !Number.isFinite(maxYear)) return 0;
  return Math.max(0, maxYear - minYear + 1);
};
